import { ReferenceNavigasi } from './reference-navigasi.model';

export class DetailNavigasi {
  constructor(public id: number, public referenceNavigasi: ReferenceNavigasi) {}
}
